<template lang="pug">
#sectionTool
  .appTools
    .level
      .type(title='剖切位置')
        span 剖切位置：
    .level
      el-checkbox(v-model='showtransform', size='mini', @change='startMoveMap') 图纸对齐工具
    i.el-icon-close.close(title='最小化', @click='closeAdd')
  el-slider.verSlider(v-model='sliderLocation', :min='min', :step='0.1', :max='max', vertical, @change='sectionLocation')
</template>

<script>
import mongeApiMlib from '@/CommonDP/mongeView/mongeApiMlib';
export default {
  data() {
    return {
      showtransform: false,
      sliderLocation: 5
    };
  },
  computed: {
    max() {
      return Math.floor(this.maxValue()?.z);
    },
    min() {
      return Math.floor(this.minValue()?.z);
    }
  },
  methods: {
    closeAdd() {
      this.$emit('closeCom', 'modelOverlayTool', false);
    },
    maxValue() {
      return mongeApiMlib.getbboxmax();
    },
    minValue() {
      return mongeApiMlib.getbboxmin();
    },
    sectionLocation() {
      mongeApiMlib.setSection(this.sliderLocation);
    },
    startMoveMap(val) {
      if (val) {
        mongeApiMlib.transformMap();
      } else {
        mongeApiMlib.stopTransformMap();
      }
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss"></style>
<style lang="scss" scoped>
.appTools {
  width: 280px;
  left: calc(50% - 140px);
}
.el-slider {
  width: 120px;
}
.verSlider {
  position: absolute;
  left: calc(50% - 70px);
  top: -75px;
  height: 100px;
  z-index: 6;
}
</style>
